







import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class AtcTaxCode extends Vue {
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value: string; //コードをバインドする
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  @Prop({ default: null }) public taxType: Common.TaxTypes;
  @Prop({ default: true }) public includeNoTax: boolean;  //taxType指定時に対象外を含めるかどうかを指定します。
  @Prop() public tooltip: string;

  public items : Common.BindItem[] = new Array();

  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;

  public created() {
    //親Editorに登録する
    if (this.editor != null) this.editor.addControl(this);
    this.$api.formatter.ensureListLoaded('taxCodeObj').then(() =>this.items = this.$api.formatter.getOptions('taxCodeObj').filter(obj=>this.taxType ? (obj.value.taxType == this.taxType || (this.includeNoTax && obj.value.taxType == Common.TaxTypes.NoTax)) : true));
  }
  @Watch('taxType')
  public onTaxTypeChanged(){
    this.items = this.$api.formatter.getOptions('taxCodeObj').filter(obj=>this.taxType ? (obj.value.taxType == this.taxType || (this.includeNoTax && obj.value.taxType == Common.TaxTypes.NoTax)) : true);
  }
  public destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }

  public get internalValue(): Common.TaxCode {
    var item = this.items.find(obj =>obj.value.code == this.value);
    return item ? item.value : null;
  }
  public set internalValue(value: Common.TaxCode) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value ? value.code : null);
    this.$emit('changed');
  }

  public async provider(){
    return this.items;
  }

}  
